import React, { useEffect } from 'react';
import {
  ATMDropdown,
  ATMField,
  ATMForm,
  ATMGrid,
  ATMInput,
} from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { useFlightOperatorContext } from 'src/contexts/flight-operator.context';
import { usePilotContext } from 'src/contexts/pilot.context';
import { OperatorPilotFormSchema } from 'src/models/operator-pilot.model';

type IProp = {
  formRef: React.RefObject<HTMLFormElement>;
  defaultValues: any;
  handleSubmit: (data) => void;
  handleEnable: (value) => void;
};

const OperatorPilotsForm: React.FC<IProp> = ({
  formRef,
  defaultValues = {},
  handleSubmit,
  handleEnable,
}) => {
  const {
    state: operatorState,
    actions: operatorActions,
  } = useFlightOperatorContext();
  const { state: pilotState, actions: pilotActions } = usePilotContext();

  useEffect(() => {
    operatorActions.listGET();
    pilotActions.listGET();
  }, [operatorActions, pilotActions]);

  const operators = operatorState.list.map((rel) => {
    return {
      key: rel.operatorId,
      text: rel.name,
      value: rel.operatorId,
    };
  });
  const pilots = pilotState.list.map((rel) => {
    return {
      key: rel.pilotId,
      text: rel.name,
      value: rel.pilotId,
    };
  });
  return (
    <div className="form-container">
      <ATMForm
        ref={formRef}
        onSubmit={handleSubmit}
        mode="onChange"
        defaultValues={defaultValues}
        validationSchema={OperatorPilotFormSchema}
      >
        {({ control, errors, formState }) => {
          handleEnable(formState.isDirty);

          return (
            <ATMGrid>
              <ATMGrid.Row columns="equal">
                <ATMGrid.Column>
                  <ATMField
                    label={Lang.LBL_OPERATOR_NAME}
                    name="operatorId"
                    control={control}
                    as={ATMDropdown}
                    placeholder={Lang.LBL_SELECT}
                    onChange={([_, { value }]) => value}
                    options={operators}
                    required
                    search
                    selection
                    fluid
                    error={errors.operatorId}
                  />
                  <ATMField
                    as={ATMInput}
                    type="hidden"
                    name="opId"
                    control={control}
                    error={errors.opId}
                  />
                </ATMGrid.Column>
                <ATMGrid.Column>
                  <ATMField
                    label={Lang.LBL_PILOT_NAME}
                    name="pilotId"
                    control={control}
                    as={ATMDropdown}
                    placeholder={Lang.LBL_SELECT}
                    onChange={([_, { value }]) => value}
                    options={pilots}
                    required
                    search
                    selection
                    fluid
                    error={errors.pilotId}
                  />
                </ATMGrid.Column>
              </ATMGrid.Row>
            </ATMGrid>
          );
        }}
      </ATMForm>
    </div>
  );
};

export default OperatorPilotsForm;
